import { useCallback, useEffect, useState } from 'react';
import type { AnalysisResult, WordTimestamp } from '../types';

export default function useWordTimestamps(result: AnalysisResult | null) {
  const [wordTimestamps, setWordTimestamps] = useState<WordTimestamp[] | null>(null);

  const extract = useCallback((res: AnalysisResult | null): WordTimestamp[] | null => {
    if (!res) return null;
    const anyRes = res as unknown as Record<string, unknown>;
    if (Array.isArray(anyRes.wordTimestamps) && (anyRes.wordTimestamps as unknown[]).length) {
      return (anyRes.wordTimestamps as unknown[]).map((w) => {
        const obj = w as Record<string, unknown>;
        return { text: String(obj.word ?? obj.text ?? ''), start: Number(obj.start ?? 0) };
      });
    }
    if (Array.isArray(anyRes.word_timestamps) && (anyRes.word_timestamps as unknown[]).length) {
      return (anyRes.word_timestamps as unknown[]).map((w) => {
        const obj = w as Record<string, unknown>;
        return { text: String(obj.word ?? obj.text ?? ''), start: Number(obj.start ?? 0) };
      });
    }
    if (Array.isArray(anyRes.transcriptWords)) {
      return (anyRes.transcriptWords as unknown[]).map((w) => {
        const obj = w as Record<string, unknown>;
        return { text: String(obj.word ?? obj.text ?? obj.token ?? ''), start: Number(obj.start ?? 0) };
      });
    }
    return null;
  }, []);

  useEffect(() => {
    const extracted = extract(result);
    setWordTimestamps(extracted);
  }, [result, extract]);

  return { wordTimestamps };
}
